import { render } from "./Loader2.vue?vue&type=template&id=cf53dc8c"
import script from "./Loader2.vue?vue&type=script&lang=js"
export * from "./Loader2.vue?vue&type=script&lang=js"

import "./Loader2.vue?vue&type=style&index=0&id=cf53dc8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__